// ./pages/About/index.jsx
import React from "react";
// import Blogsubbanner from "../../components/blogsubbanner";

const Preloader = () => {
  return (
    <>
      <div className="loader-mask">
        <div className="loader">
          <div></div>
          <div></div>
        </div>
      </div>
    </>
  );
};

export default Preloader;
